<template>
  <Modal ref="modal" class="modal-inquiry-review" :actions="actions" @action="handleAction" immediate>
    <h1>Kommentar</h1>
    <form>
      <div class="group">
        <TextareaInput fill :value.sync="icomment" />
      </div>
    </form>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';
  import TextareaInput from '@/components/ui/inputs/TextareaInput';

  export default {
    name: 'ModalInquiryComment',
    components: {
      TextareaInput,
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uuid: {
        type: String,
        default: null,
      },
      comment: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        icomment: this.comment || null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'cancel', label: i18n.t('labels.cancel') },
          { value: 'delete', label: i18n.t('labels.delete') },
          { value: 'save', label: i18n.t('labels.save') },
        ];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // async created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        if (action === 'save') {
          this.$emit('save', this.icomment);
        }
        if (action === 'delete') {
          this.$emit('delete');
        }
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-inquiry-review {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
